/**
 * @module common/DualAxis/AxisSection
 * @description 单轴配置区块壳（标题 + 可插拔表单项）
 */

import React from 'react';

export interface IAxisSectionProps {
  title: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const AxisSection: React.FC<IAxisSectionProps> = ({
  title,
  children,
  className = '',
}) => (
  <section className={`dbl-dual-axis-section ${className}`}>
    <h4 className="dbl-dual-axis-section__title">{title}</h4>
    <div className="dbl-dual-axis-section__body">{children}</div>
  </section>
);

export default React.memo(AxisSection);
